import { Cart } from './Cart';
import { Amount } from './Amount';
import { Title } from './Title';

Cart.Amount = Amount;
Cart.Title = Title;

export { Cart };
